import { Outlet } from "react-router-dom";
import { SidebarProvider } from "../ui";
import { Sidebar } from "./Sidebar";
import { cn } from "@/lib/utils";
import useLayout from "./useLayout";
import { Loader } from "../Loader";
import { Header } from "./Header";

const Layout = () => {
  const { isMasterData, isStateLoading, isUserPermissionLoading, isAdminConsole } = useLayout();

  return (
    <>
      <SidebarProvider>
        <div className="flex flex-row">
          <main className="bg-white fixed h-[100%] mt-[50px] hidden lg:block">
            <Sidebar />
          </main>
          <div>
            <Header />
            <div
              className={cn(
                "w-[100vw] mt-[50px] bg-g-10 min-h-screen text-start transition-all duration-300 ease-in-out",
                isMasterData || isAdminConsole
                  ? "lg:w-[calc(100vw-317px)]  lg:ml-[317px]"
                  : "lg:w-[calc(100vw-130px)]  lg:ml-[130px]"
              )}
            >
              {isStateLoading || isUserPermissionLoading ? <Loader /> : <Outlet />}
            </div>
            {/* <footer className="bg-white">Footer</footer> */}
          </div>
        </div>
      </SidebarProvider>
    </>
  );
};

export default Layout;
